import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Noble Mick's - Craft Beverage Company's
// "Frose' Frozen Cocktail -Just add Water + Wine" (p_cmr6c6w6je), pulled
// from Faire's live `GET /api/product-reviews/product/{product_token}`
// endpoint (the same data source that powers the product's own PDP review
// list) — verbatim comment, real reviewer, real rating, real publish date.
export const review_nm1: FaireReviewEntity = {
  token: "review_nm1",
  type: "review",
  brandName: "Noble Mick's - Craft Beverage Company",
  brandToken: "b_kxk5df5zt5",
  productToken: "p_cmr6c6w6je",
  reviewType: "product",
  reviewerName: "Sasha V.",
  reviewerLocation: "Walnut Creek, CA, United States",
  stars: 5,
  reviewText: "The frozen cocktail mixes are all so yummy and make a fun gift",
  reviewDate: "Apr 6, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T21:06:39.000Z",
    importedBy: "entity-db-cli",
  },
};
